import React, { useEffect, useRef, useState } from 'react';
import { StoriesV2 } from '@beef/smart-kit';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useIsMobileDimension } from '@beef/elk-common/hooks';

import { getIsRedesignEnabled, storiesTypeShape } from 'utils';
import { useOnScreen } from 'hooks';

import { getIndex, handleStoryDetailAnalytics, handleStoryView } from './utils/analytics';
import styles from './styles.pcss';

const cn = classnames.bind(styles);

export const StoriesComponent = ({
  stories,
  showPreview = true,
  isOpen = false,
  onClose,
  modalType = '',
  onDetailClick,
  CustomStories,
  StoryModal,
  shouldRender,
}) => {
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);
  const [swiperInstance, setSwiperInstance] = useState();
  const hasStories = stories && !!stories.length;
  const isMobile = useIsMobileDimension();

  const onSlideChangeAnalytics = (indexes) => {
    if (isVisible && hasStories) {
      const slidesList = indexes.map((slide) => ({
        position: {
          [`stories_${slide + 1}`]: {
            [stories[slide].text]: stories[slide]?.slides[0]?.link?.url || null,
          },
        },
      }));

      if (slidesList.length) {
        handleStoryView({
          list: slidesList,
        });
      }
    }
  };

  useEffect(() => {
    if (isVisible && swiperInstance) {
      onSlideChangeAnalytics(swiperInstance.visibleSlidesIndexes);
    }
  }, [isVisible, swiperInstance]);

  const onDetailAnalytics = ({ action, id, title, url }) => {
    if (hasStories) {
      handleStoryDetailAnalytics({
        index: getIndex(stories, id) + 1,
        title,
        action,
        url,
      });
    }
  };

  const Stories = CustomStories || StoriesV2;
  const isNewProfile = getIsRedesignEnabled();

  const storySliderSettings = {
    slidesOffsetBefore: isMobile ? 8 : 0,
    slidesOffsetAfter: isMobile ? 8 : 0,
    centerInsufficientSlides: !!isNewProfile,
  };

  return (
    <div ref={ref}>
      {!modalType && (
        <Stories
          StoryModal={StoryModal}
          isOpen={!!isOpen}
          lazy={false}
          list={stories}
          onClose={onClose}
          onDetailClick={(e, detail) => {
            if (!!onDetailClick && detail?.link?.url === 'ub') {
              e.preventDefault();
              onDetailClick();
            }

            onDetailAnalytics({
              id: detail.id,
              action: 'click',
              title: detail.text,
              url: detail?.slides[0]?.link?.url,
            });
          }}
          onInit={(instance) => setSwiperInstance(instance)}
          onPreviewClick={(_, preview) =>
            onDetailAnalytics({
              id: preview.id,
              action: 'open',
              title: preview.text,
              url: preview?.slides[0]?.link?.url,
            })
          }
          onSlideChange={(instance) => {
            onSlideChangeAnalytics(instance.visibleSlidesIndexes);
          }}
          onStoryView={(story) =>
            onDetailAnalytics({
              id: story.id,
              action: 'view_internal_stories',
              title: story.text,
              url: story?.slides[0]?.link?.url,
            })
          }
          previewNextBtnClassname={cn('btn', 'btn--next')}
          previewPrevBtnClassname={cn('btn', 'btn--prev')}
          shouldRender={shouldRender}
          showPreview={showPreview}
          storySliderSettings={storySliderSettings}
        />
      )}
    </div>
  );
};

StoriesComponent.propTypes = {
  stories: PropTypes.arrayOf(storiesTypeShape),
  showPreview: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  modalType: PropTypes.string,
  onDetailClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  CustomStories: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  StoryModal: PropTypes.object,
  shouldRender: PropTypes.bool,
};
